import { render } from "./EditarGradeHorariosModal.vue?vue&type=template&id=45f9731f&scoped=true"
import script from "./EditarGradeHorariosModal.vue?vue&type=script&lang=js"
export * from "./EditarGradeHorariosModal.vue?vue&type=script&lang=js"

import "./EditarGradeHorariosModal.vue?vue&type=style&index=0&id=45f9731f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45f9731f"]])

export default __exports__